module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/label.d31bdcaa.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/label.png
// module id = 2843
// module chunks = 11